import React from 'react';
import * as S from './PillSwitch.styled';
export const PillSwitch = ({ size = 'regular', items, value, onChange }) => {
    const handleClick = (value) => {
        onChange?.(value);
    };
    if (items.length === 0) {
        return null;
    }
    return (React.createElement("nav", null,
        React.createElement(S.List, null, items.map((item) => (React.createElement("li", { key: item.value },
            React.createElement(S.ItemButton, { "$size": size, "$isActive": item.value === value, onClick: () => handleClick(item.value) }, item.label)))))));
};
